import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import RoastSection from "./components/RoastSection";
import MomentsSection from "./components/MomentsSection";
import QuotesSection from "./components/QuotesSection";
import TopicsSection from "./components/TopicsSection";
import FeatureSection from "./components/FeatureSection";
import VoiceSection from "./components/VoiceSection";
import FaqSection from "./components/FaqSection";
import SubscribeSection from "./components/SubscribeSection";
import BackToTop from "./components/BackToTop";
import { faqs, roastPosts, siteMeta } from "@/mocks/guage";

const structuredData = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: siteMeta.brand,
    url: "https://y1986f1997.cn/",
    description:
      "瓜哥吃瓜专注娱乐热点锐评与吐槽，提供神点评、犀利吐槽、爆笑锐评、名场面与金句弹幕合集。",
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://y1986f1997.cn/?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: siteMeta.brand,
    url: "https://y1986f1997.cn/",
    slogan: siteMeta.slogan,
    email: siteMeta.email,
    description: siteMeta.intro,
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "瓜哥吃瓜 · 神点评与犀利吐槽",
    description:
      "瓜哥吃瓜神点评一针见血，犀利吐槽爆笑不断。名场面与金句弹幕高能频出，看热闹更看门道。",
    inLanguage: "zh-CN",
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "热门神点评",
    itemListElement: roastPosts.map((post, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: post.title,
      url: `https://y1986f1997.cn/#roast`,
    })),
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.q,
      acceptedAnswer: { "@type": "Answer", text: faq.a },
    })),
  },
];

export default function Home() {
  useEffect(() => {
    document.title = "瓜哥吃瓜 | 神点评与犀利吐槽 · 爆笑锐评名场面金句合集";
    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta(
      "description",
      "瓜哥吃瓜专注娱乐热点神点评与犀利吐槽，一针见血、爆笑不断。收录名场面、金句弹幕与事件时间线，看热闹更看门道。",
    );
    setMeta("keywords", "瓜哥吃瓜,瓜哥吃瓜神点评,瓜哥吃瓜犀利吐槽,瓜哥吃瓜爆笑锐评,瓜哥吃瓜名场面");
    setMeta("robots", "index,follow");
  }, []);

  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <RoastSection />
        <MomentsSection />
        <QuotesSection />
        <TopicsSection />
        <FeatureSection />
        <VoiceSection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <Footer />
      <BackToTop />
      {structuredData.map((data) => (
        <script
          key={data["@type"] as string}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
        />
      ))}
    </div>
  );
}